export type RateFieldPath = string | Array<string | number>;

export interface ExchangeSource {
  id: string;
  name?: string | null;
  rate: number;
  sourceUrl: string;
  fromCurrency: string;
  toCurrency: string;
  dataStructure: string;
  rateFieldPath: RateFieldPath;
  requestHeaders?: Record<string, string> | null;
  keywords?: string[] | null;
  created?: Date | null;
  updated?: Date | null;
  lastFetchedAt?: Date | null;
  schedulerEnabled?: boolean | null;
  schedulerFrequencyMinutes?: number | null;
  schedulerTimeZone?: string | null;
  schedulerJobName?: string | null;
  schedulerJobId?: string | null;
  schedulerLocation?: string | null;
  schedulerSchedule?: string | null;
  schedulerTargetBaseUrl?: string | null;

  /** When rate fetch fails (e.g. expired key), call this URL, read a field from JSON, update the given header. */
  keyRegenerationUrl?: string | null;
  keyRegenerationMethod?: string | null; // "GET" | "POST", default GET
  keyRegenerationRequestHeaders?: Record<string, string> | null;
  keyRegenerationRequestBody?: Record<string, unknown> | null; // JSON body for POST (optional)
  keyRegenerationResponseFieldPath?: RateFieldPath | null; // path to new key value in JSON
  keyRegenerationTargetHeader?: string | null; // which requestHeaders key to update (e.g. "Authorization")
}

export const EXCHANGE_SOURCES_COLLECTION = "exchangeSources";
